import styled from 'styled-components';

export const DeleteBtnLabel = styled.p`
  position: relative;

  margin-left: ${({ theme }) => theme.spacing.zero_2};

  color: ${({ theme }) => theme.colors.black_60};
  font-size: ${({ theme }) => theme.fontSize.xs};
  font-family: ${({ theme }) => theme.fontFamily.semiBold};
  line-height: ${({ theme }) => theme.lineHeight.one_2};
  letter-spacing: ${({ theme }) => theme.letterSpacing.md};
`;

export const DeleteBtnWrapper = styled.button`
  display: flex;
  align-items: center;
  padding: ${({ theme }) => theme.spacing.zero_2};
  border: none;
  border-radius: ${({ theme }) => theme.spacing.zero_2};

  background: ${({ theme }) => theme.colors.white};
  cursor: pointer;
  :hover {
    background: #ffeded;

    transition: all 0.3s ease;
  }
  :hover ${DeleteBtnLabel} {
    color: ${({ theme }) => theme.colors.negative_default};

    transition: all 0.3s ease;
  }
  :hover > svg path {
    transition: all 0.3s ease;

    stroke: ${({ theme }) => theme.colors.negative_default};
  }
`;
